function scrollToTop() {
  const button = document.getElementById('scroll-to-top');
  button.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
};

export { scrollToTop };
